import { formatMoneyCode } from "../../lib/formatMoney";

/**
 * A billing amount as the practice's billing page writes it: "49.00 CAD", the shared code style
 * (`formatMoneyCode`) that Tenant 360 and the plan-change notice use for the same figures.
 *
 * The plan catalogue (`plans.prices`), the billing breakdown and the SaaS transactions carry major
 * units (49, 24.5), the money module takes cents; the conversion rounds to the cent, never to the
 * unit. A missing or non-numeric amount is a dash, not an invented "0".
 *
 * @param {number|null|undefined} amount  major units
 * @param {string} currency               ISO code as stored (lower case); written upper case
 */
export const formatBillingAmount = (amount, currency) => {
  const n = Number(amount);
  if (amount === null || amount === undefined || amount === "" || !Number.isFinite(n)) return "—";
  return formatMoneyCode(Math.round(n * 100), currency);
};
